import React, { createContext, useState } from 'react'
import Pusher from 'pusher-js'
import { PUSHER_CONFIGS, SUBSCRIPTION_CONFIGS } from 'src/configs/app'
import { useComponentDidMount } from 'src/hooks/index'
import axios from 'axios'

export const SubscriptionContext = createContext()

export const SubscriptionProvider = ({ children }) => {
	const [pusherClient, setPusherClient] = useState()

	useComponentDidMount(() => {
		setPusherClient(
			new Pusher(SUBSCRIPTION_CONFIGS.appKey, {
				...SUBSCRIPTION_CONFIGS.options,
				authorizer: (channel) => {
					return {
						authorize: (socketId, callback) => {
							axios.defaults.withCredentials = true
							axios
								.post(PUSHER_CONFIGS.options.authEndpoint, {
									socket_id: socketId,
									channel_name: channel.name,
								})
								.then((response) => {
									callback(null, response.data)
								})
						},
					}
				},
			})
		)
	})

	return (
		<SubscriptionContext.Provider value={pusherClient}>
			{children}
		</SubscriptionContext.Provider>
	)
}
